import { useIntl } from 'react-intl'
import {KTSVG} from '../../../../../_template/helpers'
import {useListView} from '../core/ListViewProvider'

const AssignDriverEditModalHeader = () => {
  const {setItemIdForUpdate,itemIdForUpdate} = useListView()
  const intl = useIntl()
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>  {intl.formatMessage({id: 'ECOMMERCE.DRIVERS.ASSIGN'})}</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export default AssignDriverEditModalHeader
